export const styles = {
  dialogMobile: {
    '.MuiDialog-paper': {
      m: 0,
      borderRadius: 0,
      height: 1,
      maxHeight: 1,
      width: 1,

      '.MuiDialogTitle-root': {
        p: 2,
        pt: 3.25,
        pb: 0.75,
      },
      '.MuiGrid-container': {
        '&:first-of-type': {
          maxWidth: 328,
          ml: 'auto',
          mr: 'auto',
        },
      },
      '.MuiDialogContent-root': {
        p: '18px 16px 16px 16px!important', //-- open issue: https://github.com/mui/material-ui/issues/27851
      },
      '.MuiDialogActions-root': ({ palette }) => ({
        justifyContent: 'center',
        gap: 2,
        pt: 3,
        borderTop: `1px solid ${palette.grey.L80}`,
        boxShadow: '-1px 4px 20px 0px rgba(0, 0, 0, 0.10)',
        '.MuiButtonBase-root': {
          width: 156,
          minWidth: 156,
          ml: 0,
        },
      }),
    },
  },
  dialogDesktop: {
    '.MuiDialog-paper': {
      maxWidth: 378,
    },
    '.MuiDialogTitle-root': {
      pb: 2,
    },
    '.MuiDialogActions-root': {
      pt: 2,
    },
  },
};
